"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtmParameters = exports.notifcationSubType = exports.WebhookType = exports.EmailType = exports.CapitalProviderEmailType = exports.BorrowerSlackNotificationType = exports.BorrowerSlackTypeDEPRECATED = exports.BorrowerEmailType = exports.SlackGroups = void 0;
var SlackGroups;
(function (SlackGroups) {
    SlackGroups["CapMarkets"] = "capMarkets";
})(SlackGroups || (exports.SlackGroups = SlackGroups = {}));
var BorrowerEmailType;
(function (BorrowerEmailType) {
    BorrowerEmailType["assignmentEmail"] = "assignmentEmail";
    BorrowerEmailType["digestEmail"] = "digestEmail";
    BorrowerEmailType["fundingRequestEmail"] = "fundingRequestEmail";
    BorrowerEmailType["fundingRequestSubmittedBorrowerEmail"] = "fundingRequestSubmittedBorrowerEmail";
    BorrowerEmailType["fundingRequestSubmittedCapitalProviderEmail"] = "fundingRequestSubmittedCapitalProviderEmail";
    BorrowerEmailType["fundingRequestApproval"] = "fundingRequestApproval";
    BorrowerEmailType["upcomingDeliverableEmail"] = "upcomingDeliverableEmail";
    // v4 deliverables
    BorrowerEmailType["deliverablesDueSoon"] = "deliverablesDueSoon";
    BorrowerEmailType["deliverablesNewComment"] = "deliverablesNewComment";
    BorrowerEmailType["deliverablesReportLenderReviewResult"] = "deliverablesReportLenderReviewResult";
    BorrowerEmailType["deliverablesReportGeneratedResult"] = "deliverablesReportGeneratedResult";
    // @jendevelops this is not really a borrower only email type, but will leave here for now
    BorrowerEmailType["deliverablesResponsiblePartyReminder"] = "deliverablesResponsiblePartyReminder";
    BorrowerEmailType["deliverablesResponsiblePartySubmitSubmission"] = "deliverablesResponsiblePartySubmitSubmission";
    BorrowerEmailType["deliverablesResponsiblePartyStatusUpdate"] = "deliverablesResponsiblePartyStatusUpdate";
    BorrowerEmailType["servicerReportPreviewEmail"] = "servicerReportPreviewEmail";
    BorrowerEmailType["servicerReportFailureEmail"] = "servicerReportFailureEmail";
    BorrowerEmailType["dataTapeIngestionErrors"] = "dataTapeIngestionErrors";
    BorrowerEmailType["borrowingBaseReportGenerated"] = "borrowingBaseReportGenerated";
    BorrowerEmailType["masterTrustPortfolioOverview"] = "masterTrustPortfolioOverview";
    BorrowerEmailType["metricAlert"] = "metricAlert";
    BorrowerEmailType["remediationRequestedBorrowerAction"] = "remediationRequestedBorrowerAction";
    BorrowerEmailType["verificationReportAdjudicationAction"] = "verificationReportAdjudicationAction";
    BorrowerEmailType["verificationReportCreatedBorrower"] = "verificationReportCreatedBorrower";
    BorrowerEmailType["verificationReportReadyForReviewBorrower"] = "verificationReportReadyForReviewBorrower";
    BorrowerEmailType["invoiceCalculationComparison"] = "invoiceCalculationComparison";
    BorrowerEmailType["successfulIbsTransactionIngest"] = "successfulIbsTransactionIngest";
})(BorrowerEmailType || (exports.BorrowerEmailType = BorrowerEmailType = {}));
var BorrowerSlackTypeDEPRECATED;
(function (BorrowerSlackTypeDEPRECATED) {
    BorrowerSlackTypeDEPRECATED["UpdateDeliverableStatusDueSoon"] = "updateDeliverableStatusDueSoon";
    BorrowerSlackTypeDEPRECATED["UpdateDeliverableStatusOverdue"] = "updateDeliverableStatusOverdue";
    BorrowerSlackTypeDEPRECATED["UpdateDeliverableStatusCompleted"] = "UpdateDeliverableStatusCompleted";
    BorrowerSlackTypeDEPRECATED["TargetFundingRequest"] = "targetFundingRequest";
    BorrowerSlackTypeDEPRECATED["FundingRequestPostSubmit"] = "fundingRequestPostSubmit";
    BorrowerSlackTypeDEPRECATED["FundingRequestExpire"] = "fundingRequestExpire";
})(BorrowerSlackTypeDEPRECATED || (exports.BorrowerSlackTypeDEPRECATED = BorrowerSlackTypeDEPRECATED = {}));
var BorrowerSlackNotificationType;
(function (BorrowerSlackNotificationType) {
    BorrowerSlackNotificationType["dataTapeIngestionError"] = "dataTapeIngestionErrors";
    BorrowerSlackNotificationType["metricAlert"] = "metricAlert";
    // @jendevelops this is not really a borrower only slack type, but will leave here for now
    BorrowerSlackNotificationType["deliverablesResponsiblePartyReminder"] = "deliverablesResponsiblePartyReminder";
    BorrowerSlackNotificationType["deliverablesResponsiblePartySubmitSubmission"] = "deliverablesResponsiblePartySubmitSubmission";
    BorrowerSlackNotificationType["deliverablesResponsiblePartyStatusUpdate"] = "deliverablesResponsiblePartyStatusUpdate";
    BorrowerSlackNotificationType["fundingRequestApproval"] = "fundingRequestApproval";
    BorrowerSlackNotificationType["fundingRequestAutoGenerated"] = "fundingRequestAutoGenerated";
    BorrowerSlackNotificationType["fundingRequestExpired"] = "fundingRequestExpired";
    BorrowerSlackNotificationType["fundingRequestPostSubmit"] = "fundingRequestPostSubmit";
    // old deliverables stuff (deprecated)
    BorrowerSlackNotificationType["deliverableStatusUpdate"] = "deliverableStatusUpdate";
    // workflow generic emails
    BorrowerSlackNotificationType["workflowGenericNotifyApproval"] = "workflowGenericNotifyApproval";
})(BorrowerSlackNotificationType || (exports.BorrowerSlackNotificationType = BorrowerSlackNotificationType = {}));
var CapitalProviderEmailType;
(function (CapitalProviderEmailType) {
    CapitalProviderEmailType["receivablesSaleAgreementGenerated"] = "receivablesSaleAgreementGenerated";
    CapitalProviderEmailType["fundingRequestSubmittedCapitalProviderEmail"] = "fundingRequestSubmittedCapitalProviderEmail";
    CapitalProviderEmailType["fundingRequestApproval"] = "fundingRequestApproval";
    CapitalProviderEmailType["borrowingBaseReportGenerated"] = "borrowingBaseReportGenerated";
    CapitalProviderEmailType["dataTapeIngestionErrors"] = "dataTapeIngestionErrors";
    CapitalProviderEmailType["remediationRequestedCapitalProviderReceipt"] = "remediationRequestedCapitalProviderReceipt";
    CapitalProviderEmailType["verificationReportAdjudicationAction"] = "verificationReportAdjudicationAction";
    CapitalProviderEmailType["verificationReportReadyForReviewCapitalProvider"] = "verificationReportReadyForReviewCapitalProvider";
    // v4 deliverables
    CapitalProviderEmailType["deliverablesNewComment"] = "deliverablesNewComment";
    CapitalProviderEmailType["deliverablesReportReadyForReview"] = "deliverablesReportReadyForReview";
    // workflow generic emails
    CapitalProviderEmailType["workflowGenericNotifyApproval"] = "workflowGenericNotifyApproval";
    CapitalProviderEmailType["missingPipelineInputs"] = "missingPipelineInputs";
    CapitalProviderEmailType["invoiceCalculationComparison"] = "invoiceCalculationComparison";
    CapitalProviderEmailType["successfulIbsTransactionIngest"] = "successfulIbsTransactionIngest";
})(CapitalProviderEmailType || (exports.CapitalProviderEmailType = CapitalProviderEmailType = {}));
exports.EmailType = {
    ...BorrowerEmailType,
    ...CapitalProviderEmailType,
};
var WebhookType;
(function (WebhookType) {
    WebhookType["fundingRequestApprovedWebhook"] = "fundingRequestApprovedWebhook";
    WebhookType["borrowingBaseReportGeneratedWebhook"] = "borrowingBaseReportGeneratedWebhook";
    WebhookType["assignmentAssignEventWebhook"] = "assignmentAssignEventWebhook";
})(WebhookType || (exports.WebhookType = WebhookType = {}));
exports.notifcationSubType = {
    ...BorrowerEmailType,
    ...CapitalProviderEmailType,
    ...WebhookType,
};
var UtmParameters;
(function (UtmParameters) {
    UtmParameters.UTM_PARAMETER_Properties = ['utm_source', 'utm_medium'];
})(UtmParameters || (exports.UtmParameters = UtmParameters = {}));
//# sourceMappingURL=Notifications.js.map